import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

function Footer() {
  const { lang } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} Red-Database-Security GmbH. {t(lang, 'footer_rights')}
        </div>
        <div className="footer-links">
          <Link to="/">{t(lang, 'nav_home')}</Link>
          <Link to="/about">{t(lang, 'nav_about')}</Link>
          <Link to="/contact">{t(lang, 'nav_contact')}</Link>
          <Link to="/impressum">{t(lang, 'nav_impressum')}</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
